let lastScrollTop = 0;
let scrollThreshold = 10;
const header = document.querySelector('.header-wrapper');

window.addEventListener('scroll', function() {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  // If at the top of the page, remove hide class
  if (scrollTop === 0) {
    header.classList.remove('hide');
    return;
  }
  
  // Check if scrolled more than threshold
  if (Math.abs(scrollTop - lastScrollTop) > scrollThreshold) {
    // Scrolling down
    if (scrollTop > lastScrollTop) {
      header.classList.add('hide');
    } 
    // Scrolling up (but not at top)
    else {
      header.classList.remove('hide');
    }
    
    lastScrollTop = scrollTop;
  }
});